<template>
  <v-card flat class="measure-bar">
    <v-app-bar elevation="1" class="px-11">
      <v-app-bar-title class="text-primary text-h6 font-weight-bold">
        My Reports
      </v-app-bar-title>
      <v-text-field
        class="mt-1"
        hide-details
        prepend-inner-icon="mdi-magnify"
        single-line
        bg-color="white"
        variant="outlined"
        density="compact"
        :placeholder="placeholder"
        :clearable="true"
        @click:clear="() => handleSearchInput"
        @update:modelValue="handleSearchInput"
      />
      <v-spacer />
    </v-app-bar>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const placeholder = computed<string>(() => {
  return String(useRoute().meta.placeholder || 'Search for a Report');
});

const store = useStore();
const setReportSearchTerm = (value: string) => {
  store.commit('ViewSupportStore/ReportsStore/REPORT_SEARCH_TERM', value);
};

const handleSearchInput = (value: string | object) => {
  if (typeof value === 'object') {
    setReportSearchTerm('');
  } else {
    setReportSearchTerm(value);
  }
};
</script>
<style lang="scss" scoped>
.measure-bar {
  z-index: 1;
}

.v-input {
  max-width: 700px !important;
}

:deep(.v-field__input) {
  color: $primary !important;
}

:deep(.bg-white) {
  color: $primary !important;
}
</style>
